import React from "react";
import type { CSSProperties } from "react";

interface Props {
  props: string;
}

const BENEFITS = [
  {
    icon: "icon-phone-call",
    title: "Service Client 24/7",
    description:
      "Nous sommes ici pour vous aider avec toutes vos questions ou préoccupations, 24/7.",
  },
  {
    icon: "icon-guarantee",
    title: "Notre Garantie",
    description:
      "Nous garantissons la qualité de nos produits et services, et nous assurons votre satisfaction.",
  },
  {
    icon: "icon-delivery-truck",
    title: "Livraison mondiale",
    description:
      "Nous expédions nos produits dans le monde entier, les rendant accessibles à tous nos clients.",
  },
] as const;

const Benefit: React.FC<Props> = ({ props }) => {
  return (
    <>
      <div className="container">
        <div className={`benefit-block kissaria-benefit-section ${props}`}>
          <div className="kissaria-benefit-section__panel">
            <div className="list-benefit grid items-stretch lg:grid-cols-3 grid-cols-1 gap-5 md:gap-6 lg:gap-8">
              {BENEFITS.map((item, index) => (
                <div
                  key={item.title}
                  className="fx-reveal kissaria-benefit-card group relative flex flex-col items-center text-center rounded-2xl border border-line bg-white/90 px-6 py-8 md:px-7 md:py-10 transition-all duration-300 ease-out hover:border-pink/20 hover:shadow-[0_14px_44px_rgba(255,67,112,0.1)] hover:-translate-y-0.5"
                  style={
                    {
                      "--fx-delay": `${index * 120}ms`,
                    } as CSSProperties
                  }
                >
                  <span
                    className="kissaria-benefit-card__glow pointer-events-none absolute inset-x-6 top-0 h-px rounded-full bg-gradient-to-r from-transparent via-pink/35 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                    aria-hidden
                  />
                  <div className="kissaria-benefit-card__icon mb-5 flex h-[4.25rem] w-[4.25rem] shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-pink/[0.12] to-pink/[0.04] shadow-[inset_0_1px_0_rgba(255,255,255,0.8)] ring-1 ring-pink/10 transition-transform duration-300 ease-out group-hover:scale-[1.06] md:h-[4.75rem] md:w-[4.75rem]">
                    <i
                      className={`${item.icon} text-[2.5rem] md:text-[2.75rem] text-pink leading-none`}
                    />
                  </div>
                  <div className="heading6 text-pink font-semibold">
                    {item.title}
                  </div>
                  <div className="caption1 text-secondary mt-3 max-w-[22rem] leading-relaxed">
                    {item.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Benefit;
